import { Component, OnInit, Input, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocDefPrimLibService } from '../../../doc-def-prim-lib.service';
import { DOData, NJDocData, modalParams, ModalParamsElem } from "../../DOData";
import { SectionTableComponent, DOTextBoxComponent } from 'projects/doc-def-prim-lib/src/public-api';


@Component({
  selector: 'cy-diagnosis-child-window',
  templateUrl: './diagnosis-child-window.component.html',
  styleUrls: ['./diagnosis-child-window.component.css']
})
export class DiagnosisChildWindowComponent implements OnInit {

    //#region Data from API
    public loaderKey: string;
    public apiController: string;
    //#endregion

    @Input() modal_title: string = "";
    @Input() calledFrom: string = "";   // TODO Value will vary depending on caller component, From Facesheet: "FormType:Face"
    @Input() calledFromID: number = 0;  // TODO Value will be an assessment ID, but From Facesheet: 0

    //@Input() public diagnosis;

    public listDocdata: Array<Array<DOData>>;
    public listDocdataFooter: Array<Array<DOData>>;

    private tabCode: string;
    private tabCodeFooter: string;
    private strDocDefTypeSubCode: string = "Wrappers";
    private gridTemplateCode: string = "Wrappers_Grid1_";

    private _canClick: boolean = true;

    public isDataAvailable: boolean = false;
    private diagnosisData: Array<DOData> = new Array<DOData>();

    private primitivesGrid: SectionTableComponent;
    private primitives: Array<DOData>;
    private primitives2: Array<DOData>;

    public validationMsgs: string = "";

    private selectedDiag: Array<DOData> = new Array<DOData>();
    private objDiag: {};

    constructor(public activeModal: NgbActiveModal, private dataLib: DocDefPrimLibService) { }

    public returnResponse() {
        this.activeModal.close(this.selectedDiag);
    }
    public dismiss() {
        this.activeModal.dismiss(new Array<NJDocData>());
    }
    mobHeight: number;
    mobWidth: number;
    height: Number = 50;
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.mobHeight = event.target.innerHeight;
        this.mobWidth = event.target.innerWidth;
        this.height = this.mobHeight * 0.5;
    }

    ngOnInit() {
        this.apiController = "ApiDocDefPrim";
        this.loaderKey = "Wrappers";
        this.tabCode = "Wrappers_Tab_Search Diagnosis (pop up) - Tab";
        this.tabCodeFooter = "Wrappers_Tab_Search Diagnosis Footer";

        this.gridTemplateCode = "Wrappers_Grid1_";

        this.initSetup();
    }

    // Init Load
    initSetup() {
        this.loadSearchDiagnosis("");
    }

    loadSearchDiagnosis(gridTemplateCode: string) {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tabCode;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = gridTemplateCode;
        var elem: ModalParamsElem = new ModalParamsElem();
        let arrCalledFrom = this.calledFrom.split(":");
        elem.value = arrCalledFrom[1];
        elem.param = "CalledFrom";
        params.lstModalParams.push(elem);
        var elem2: ModalParamsElem = new ModalParamsElem();
        elem2.value = this.calledFromID.toString();
        elem2.param = "CalledFromID";
        params.lstModalParams.push(elem2);

        this.dataLib.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst);
                        }
                        this.listDocdata = localListDocdata;
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete- loadSearchDiagnosis')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //if (typeof (Event) === 'function') {
                    //    // modern browsers
                    //    window.dispatchEvent(new Event('resize'));
                    //} else {
                    //    //This will be executed on old browsers and especially IE
                    //    var resizeEvent = window.document.createEvent('UIEvents');
                    //    resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //    window.dispatchEvent(resizeEvent);
                    //}
                    //this.ModalWait.close("");
                    this.loadFooter(false);                }
            );
    }

    loadFooter(validate: boolean) {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tabCodeFooter;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = "";
        this.dataLib.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst);
                        }
                        this.listDocdataFooter = localListDocdata;

                        this.isDataAvailable = true;
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete- loadSearchDiagnosisFooter')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    if (typeof (Event) === 'function') {
                        // modern browsers
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        //This will be executed on old browsers and especially IE
                        var resizeEvent = window.document.createEvent('UIEvents');
                        resizeEvent.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(resizeEvent);
                    }

                    if (!validate) {
                        //this.finishLoad();
                    }
                }
            );
    }

    showValidationMessages(msg: string) {
        if (msg != "") {
            this.validationMsgs = msg;
        }
        else {
            this.validationMsgs = "";
        }
    }

    getDOData(templateCode: string) {
        let objDOData = null;
        this.listDocdata.forEach(ldo => {
            ldo.forEach(d => {
                if (d.njDocDefTemplate.templateCode == templateCode) {
                    objDOData = d;
                }
            });
        });
        return objDOData;
    }

    getDODataFromFooter(templateCode: string) {
        let objDOData = null;
        this.listDocdataFooter.forEach(ldo => {
            ldo.forEach(d => {
                if (d.njDocDefTemplate.templateCode == templateCode) {
                    objDOData = d;
                }
            });
        });
        return objDOData;
    }

    onClickButton(d: DOData) {

        switch (d.njDocDefTemplate.tType) {

            case "Button": {

                switch (d.njDocDefTemplate.templateCode) {
                    // Search
                    case "Wrappers_Button_Search": {
                        if (this._canClick) {
                            setTimeout(() => {
                                this.searchDiagnosis();                                
                            }, 500);
                        }
                        break;
                    }

                    //Cancel
                    case "Wrappers_Button_Cancel": {
                        this.dismiss();
                        break;
                    }

                    // OK
                    case "Wrappers_Button_OK": {
                        if (this._canClick) {

                            let validationMsgs = "";
                            let invalidSelect = "You must select a diagnosis before continuing."

                            let gridComponent = this.primitivesGrid.GridInternalAgGridComponents.first;

                            //let result = gridComponent.getSelectedRowData();
                            let result = gridComponent.selectedRow;
                            if (result != null && result["id"] != null && result["id"] != "") {
                                this.sendSelectedDiag(result);
                            }
                            else {
                                validationMsgs = invalidSelect;
                            }

                            if (validationMsgs != "") {
                                this.showValidationMessages(validationMsgs);
                            }
                        }
                        break;
                    }
                    case "Wrappers_TOSection_Search Diagnosis (pop up)  - TOSection_Button_Clear":
                        this.primitivesGrid.GridInternalAgGridComponents.first.SetFilterModel("", "");
                        this.primitivesGrid.TextBoxComponents.find(a => a.DocDefTemplate.templateCode == "Wrappers_TextBox_Code").clearTextbox();
                        this.primitivesGrid.TextBoxComponents.find(a => a.DocDefTemplate.templateCode == "Wrappers_TextBox_Description").clearTextbox();
                        break;
                    default: {
                        break;
                    }
                }
                break;
            }

            default: {
                break;
            }
        }
    }

    // Catch event emitted from ag-grid
    onGridDoubleClick(d: DOData) {
        switch (d.njDocDefTemplate.templateCode) {
            case "Wrappers_Grid1_": {
                if (this._canClick) {
                    let gridComponent = this.primitivesGrid.GridInternalAgGridComponents.first;
                    //let result = gridComponent.getSelectedRowData();
                    let result = gridComponent.selectedRow;
                    this.sendSelectedDiag(result);
                }
                break;
            }
            default: {
                break;
            }
        }
    }

    // Send selected row back to Add/Edit Diagnosis grid
    sendSelectedDiag(result: {}) {
        //on error return empty array
        this.selectedDiag = new Array<DOData>();
        // find grid
        let lstGrid: Array<DOData>;
        for (var i: number = 0; i < this.listDocdata.length; i++) {
            lstGrid = this.listDocdata[i].filter(function (item) {
                return item.njDocDefTemplate.tType == "Grid1"
            });
        };
        //get diag data
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        if (lstGrid.length == 1) {
            //get grid data
            //lstGridData = lstGrid[0].lstDocData;
            lstGridData = this.buildDiagData(result, lstGrid);
            // get selected row from col of diag key and value selected
            // find template of key from template code in custom paramater
            let templateCodeKey = lstGrid[0].customParameters.KeyColumnField;
            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item) {
                return item.templateCode == templateCodeKey;
            });
            if (lstTemplate.length == 1) {
                // find template id of key
                let docDefTemplateID = lstTemplate[0].docDefTemplateID;
                // get NJDocData of selected item 
                let lstdata = lstGridData.filter(function (item) {
                    return item.docDefTemplateID == docDefTemplateID && item.dataValue == result["T" + docDefTemplateID.toString()].toString();
                });
                // get the selected row using docDefDataRowID
                if (lstdata.length == 1) {
                    for (var item of lstGridData) {
                        if (item.docDefDataRowID == lstdata[0].docDefDataRowID) {
                            let doData = new DOData();
                            doData.njDocData = item;
                            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                                return item1.docDefTemplateID == item.docDefTemplateID;
                            });
                            if (lstTemplate.length == 1) {
                                doData.njDocDefTemplate = lstTemplate[0];
                            }
                            doData.njDocDefTemplate
                            this.selectedDiag.push(doData);
                        }
                    }
                }
            }
        }

        // Diagnosis Comment
        let txtDiagComment: DOTextBoxComponent = this.primitivesGrid.TextBoxComponents.filter(t => t.DocDefTemplate.templateCode == "Wrappers_TOSection_Search Diagnosis (pop up)  - TOSection_TextBox_Comments_Search")[0];
        let doDataDiagComment = new DOData();
        doDataDiagComment.njDocData = txtDiagComment.DocData;
        doDataDiagComment.njDocDefTemplate = txtDiagComment.DocDefTemplate;

        this.selectedDiag.push(doDataDiagComment);

        this.returnResponse();
    }

    buildDiagData(result: {}, lstGrid: DOData[]) {
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();

        for (var item of lstGrid[0].lstChildDocDefTemplate) {
            let njDocData: NJDocData = new NJDocData();
            njDocData.dataValue = result["T" + item.docDefTemplateID.toString()];
            njDocData.docDataHdrId = -1;
            njDocData.docDefDataRowID = result["id"];
            njDocData.docDefDataRowParID = 0;
            njDocData.docDefTemplateID = item.docDefTemplateID;
            lstGridData.push(njDocData);
        }

        return lstGridData;
    }

    searchDiagnosis() {
        this.dataLib.loadGetGridDataSP(this.apiController, this.gridTemplateCode, {})
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        // find grid
                        let lstGrid: Array<DOData>;
                        for (var i: number = 0; i < this.listDocdata.length; i++) {
                            lstGrid = this.listDocdata[i].filter(function (item) {
                                return item.njDocDefTemplate.tType == "Grid1"
                            });
                        };
                        //set grid data
                        if (lstGrid.length == 1) {
                            lstGrid[0].lstDocData = this.dataLib.gridData;
                        }
                        this.primitivesGrid.GridInternalAgGridComponents.first.callGridRefresh();
                    }
                },
                (err: any) => console.log(err)
            );
    }


    sectionGrid_tableAfterViewInit(c: SectionTableComponent) {
        if (c.TextBoxComponents.first != undefined &&
            c.TextBoxComponents.first.DocDefTemplate.templateCode == "Wrappers_TextBox_Code") {
            this.primitivesGrid = c;
            this.primitives = c.getPrimitives();
        }
    }

    sectionGrid_tableAfterViewInit_footer(c: SectionTableComponent) {
    }
}
